/**
 * Padding horizontal del carril: deja sitio para el thumb (20px) centrado en 0% y 100%
 * sin recortarse. Debe aplicarse igual en `RangeBar` y en filas de `RangeSelector` alineadas a la pista.
 */
export const RANGE_BAR_TRACK_BLEED_X = 'ui-px-[10px]' as const;
